import { refundRoles, snackbarOperationsRoles } from '@/utils/safariRefundAccess'

export default {
  path: '/safari',
  name: 'safari',
  component: () => import('@/views/safari/Index'),
  redirect: { name: 'safari-groups' },
  children: [
    {
      path: 'groups',
      component: () => import('@/views/safari/groups/Index'),
      children: [
        {
          path: '',
          component: () => import('@/views/safari/groups/list/Layout'),
          children: [
            {
              path: '',
              name: 'safari-groups',
              component: () => import('@/views/safari/groups/list/Upcoming'),
              meta: {
                title: 'Safari groups',
                roles: ['general_manager', 'sales_manager', 'operations_manager', 'safari_supervisor', 'safari_manager', 'safari_assistant', 'sales_supervisor', 'operations_supervisor', 'support']
              },
            },
            {
              path: 'in-tour',
              name: 'safari-groups-tour',
              component: () => import('@/views/safari/groups/list/InTour'),
              meta: {
                title: 'Safari groups',
                roles: ['general_manager', 'sales_manager', 'operations_manager', 'safari_supervisor', 'safari_manager', 'safari_assistant', 'sales_supervisor', 'operations_supervisor', 'support']
              },
            },
            {
              path: 'cancelled',
              name: 'safari-groups-cancelled',
              component: () => import('@/views/safari/cancellations/List'),
              meta: { title: 'Cancelled Safari groups', roles: ['general_manager', 'support', 'finance_manager', 'accountant_manager', 'accountant_supervisor', 'sales_manager', 'sales_supervisor', 'safari_supervisor', 'safari_manager', 'safari_assistant', 'operations_manager', 'operations_supervisor'] },
            },
            {
              path: 'archive',
              name: 'safari-groups-archive',
              component: () => import('@/views/safari/groups/list/Archive'),
              meta: {
                title: 'Safari groups',
                roles: ['general_manager', 'sales_manager', 'operations_manager', 'safari_supervisor', 'safari_manager', 'safari_assistant', 'sales_supervisor', 'operations_supervisor', 'support']
              },
            },
          ]
        },
        {
          path: ':id',
          name: 'safari-groups-detail',
          component: () => import('@/views/safari/groups/detail/Layout'),
          redirect: { name: 'safari-groups-detail-clients' },
          children: [
            {
              path: '',
              name: 'safari-groups-detail-clients',
              component: () => import('@/views/safari/groups/detail/Clients'),
              meta: {
                roles: ['general_manager', 'sales_manager', 'operations_manager', 'safari_supervisor', 'safari_manager', 'safari_assistant', 'sales_supervisor', 'operations_supervisor', 'support']
              }
            },
            {
              path: 'drivers-itinerary',
              name: 'safari-groups-detail-drivers-itinerary',
              component: () => import('@/views/safari/groups/detail/DriversItinerary'),
              meta: {
                roles: ['general_manager', 'sales_manager', 'sales_supervisor', 'safari_supervisor', 'operations_manager', 'operations_supervisor']
              }
            },
            {
              path: 'np',
              name: 'safari-groups-detail-np',
              component: () => import('@/views/safari/groups/detail/NP'),
              meta: {
                roles: ['general_manager', 'safari_supervisor', 'operations_supervisor']
              }
            },
            {
              path: 'snacks',
              name: 'safari-groups-detail-snacks',
              component: () => import('@/views/safari/groups/detail/Snacks'),
              meta: {
                roles: ['general_manager', 'sales_manager', 'safari_supervisor', 'safari_manager', 'safari_assistant', 'sales_supervisor', 'operations_supervisor']
              }
            },
            {
              path: 'cars',
              name: 'safari-groups-detail-cars',
              component: () => import('@/views/safari/groups/detail/Cars'),
              meta: {
                roles: ['general_manager', 'safari_supervisor', 'sales_supervisor', 'sales_manager', 'operations_supervisor']
              }
            },
            {
              path: 'transfers',
              name: 'safari-groups-detail-transfers',
              component: () => import('@/views/safari/groups/detail/Transfers'),
              meta: {
                roles: ['general_manager', 'sales_manager', 'operations_manager', 'safari_supervisor', 'safari_manager', 'safari_assistant', 'operations_supervisor']
              }
            },
            {
              path: 'downloads',
              name: 'safari-groups-detail-downloads',
              component: () => import('@/views/safari/groups/detail/Downloads'),
              meta: {
                roles: ['general_manager', 'safari_supervisor']
              }
            },
          ]
        },
        {
          path: ':id/expenses/:cashId',
          name: 'safari-groups-detail-expenses-detail',
          component: () => import('@/views/safari/groups/detail/ExpensesDetail'),
          meta: {
            roles: ['general_manager', 'sales_manager', 'safari_supervisor', 'safari_manager', 'safari_assistant']
          }
        },
      ]
    },
    {
      path: 'snack-bar',
      component: () => import('@/views/safari/snack-bar/Layout'),
      children: [
        {
          path: 'refunds',
          name: 'safari-snackbar-refunds',
          component: () => import('@/views/safari/cancellations/RefundList'),
          meta: { title: 'Snackbar refunds', roles: refundRoles },
        },
        {
          path: '',
          name: 'safari-snack-bar',
          component: () => import('@/views/safari/snack-bar/Upcoming'),
          meta: {
            title: 'Snack bar requests',
            roles: snackbarOperationsRoles
          },
        },
        {
          path: 'in-tour',
          name: 'safari-snack-bar-tour',
          component: () => import('@/views/safari/snack-bar/InTour'),
          meta: {
            title: 'Snack bar requests',
            roles: snackbarOperationsRoles
          },
        },
        {
          path: 'archive',
          name: 'safari-snack-bar-archive',
          component: () => import('@/views/safari/snack-bar/Archive'),
          meta: {
            title: 'Snack bar requests',
            roles: snackbarOperationsRoles
          },
        },
      ]
    },
    {
      path: 'schedule',
      component: () => import('@/views/safari/schedule/Layout'),
      children: [
        {
          path: '',
          name: 'safari-schedule-list',
          component: () => import('@/views/safari/schedule/List'),
          meta: {
            title: 'Safari cars schedule',
            roles: ['general_manager', 'safari_supervisor', 'safari_manager', 'safari_assistant', 'sales_manager', 'sales_supervisor']
          }
        },
        {
          path: 'calendar',
          name: 'safari-schedule-calendar',
          component: () => import('@/views/safari/schedule/Calendar'),
          props: { mode: 'car', switchable: true },
          meta: {
            title: 'Safari schedule calendar',
            roles: ['general_manager', 'safari_supervisor', 'safari_manager', 'safari_assistant', 'sales_manager', 'sales_supervisor']
          }
        },
        {
          path: 'honeymooners',
          name: 'safari-schedule-honeymooners',
          component: () => import('@/views/safari/schedule/Honeymooners'),
          meta: {
            title: 'Safari Honeymooners schedule',
            roles: ['general_manager', 'safari_supervisor', 'safari_manager', 'safari_assistant', 'sales_manager', 'sales_supervisor']
          }
        },
        {
          path: 'combined-calendar',
          redirect: { name: 'safari-schedule-calendar' },
          meta: {
            title: 'Safari schedule calendar',
            roles: ['general_manager', 'safari_supervisor', 'safari_manager', 'safari_assistant', 'sales_manager', 'sales_supervisor']
          }
        },
        {
          path: 'guide-calendar',
          redirect: { name: 'safari-schedule-calendar' },
          meta: {
            title: 'Safari schedule calendar',
            roles: ['general_manager', 'safari_supervisor', 'safari_manager', 'safari_assistant', 'sales_manager', 'sales_supervisor']
          }
        },
        {
          path: 'problems',
          name: 'safari-schedule-problems',
          component: () => import('@/views/safari/schedule/Problems'),
          meta: {
            title: 'Safari problems',
            roles: ['general_manager', 'safari_supervisor', 'safari_manager', 'safari_assistant']
          }
        },
      ]
    },
    {
      path: 'cars-drivers',
      name: 'safari-cars-drivers',
      component: () => import('@/views/safari/cars-drivers/List'),
      meta: {
        title: 'Safari cars & drivers',
        roles: ['general_manager', 'safari_supervisor']
      }
    },
    {
      path: 'drivers',
      component: () => import('@/views/safari/drivers/Index'),
      children: [
        {
          path: '',
          name: 'safari-drivers-list',
          redirect: { name: 'safari-cars-drivers' },
        },
        {
          path: ':id',
          name: 'safari-drivers-detail',
          component: () => import('@/views/safari/drivers/Detail'),
          meta: {
            title: 'Driver',
            roles: ['general_manager', 'safari_supervisor', 'safari_manager', 'safari_assistant']
          }
        }
      ]
    },
    {
      path: 'cars',
      component: () => import('@/views/safari/cars/Index'),
      children: [
        {
          path: '',
          name: 'safari-cars-list',
          redirect: { name: 'safari-cars-drivers' },
        },
        {
          path: ':id',
          name: 'safari-cars-detail',
          component: () => import('@/views/safari/cars/Detail'),
          meta: {
            title: 'Safari car',
            roles: ['general_manager', 'safari_supervisor', 'safari_manager', 'safari_assistant']
          }
        },
      ]
    },
    {
      path: 'allowance',
      component: () => import('@/views/safari/allowance/Index'),
      children: [
        {
          path: '',
          name: 'safari-allowance-list',
          component: () => import('@/views/safari/allowance/List'),
          meta: {
            title: 'Driver’s allowance',
            roles: ['general_manager', 'safari_supervisor', 'safari_manager', 'safari_assistant']
          }
        },
        {
          path: ':id',
          name: 'safari-allowance-detail',
          component: () => import('@/views/safari/allowance/Detail'),
          meta: {
            title: 'Driver allowance',
            roles: ['general_manager', 'safari_supervisor', 'safari_manager', 'safari_assistant']
          }
        },
      ]
    },
    {
      path: 'analytics',
      component: () => import('@/views/safari/analytics/Layout'),
      children: [
        {
          path: '',
          name: 'safari-analytics-general',
          component: () => import('@/views/safari/analytics/General'),
          meta: {
            title: 'Safari analytics',
            roles: ['general_manager', 'safari_supervisor']
          }
        },
        {
          path: 'snack-bar',
          name: 'safari-analytics-snacks',
          component: () => import('@/views/safari/analytics/SnackBar'),
          meta: {
            title: 'Safari analytics',
            roles: ['general_manager', 'safari_supervisor']
          }
        },
        {
          path: 'flying-doctors',
          name: 'safari-analytics-flying-doctors',
          component: () => import('@/views/safari/analytics/FlyingDoctors'),
          meta: {
            title: 'Flying Doctors',
            roles: ['general_manager', 'safari_flying_doctors']
          }
        },
      ],
    },
    {
      path: 'flying-doctors',
      component: () => import('@/views/safari/flying-doctors/Index'),
      children: [
        {
          path: '',
          component: () => import('@/views/safari/flying-doctors/Layout'),
          children: [
            {
              path: '',
              name: 'safari-doctors-list-upcoming',
              component: () => import('@/views/safari/flying-doctors/UpcomingList'),
              meta: {
                title: 'Flying doctors insurance',
                roles: ['safari_flying_doctors', 'safari_supervisor', 'safari_manager', 'safari_assistant']
              }
            },
          ]
        }
      ]
    },
  ]
}
